// import React, { memo,useState,ReactElement } from "react";
import React, { useEffect, useState } from "react";
import styles from "./EditAdminPage.module.css";
import "react-tabs/style/react-tabs.css";
import { useSpring, animated } from "react-spring";
import UploadVideo from "./UploadVideo";
import { Box, createTheme, makeStyles, Tab, Tabs, Theme, ThemeProvider } from "@material-ui/core";
import OnLeaveDialog from "../../common/components/dialog/OnLeaveDialog";
import EditUser from "./EditUser";
import ConfirmProcessStatusIndex from "../../pages/admin/ConfirmProcessStatus/ConfirmProcessStatusIndex";
import EditGroup from "../../pages/admin/EditGroup/EditGroup";
import EditProgram from "./EditProgram";
import EditRecommend from "./EditRecommend";
import UploadContent from "./UploadSlideStock";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../root/RootReducer";
import { DeleteTempFile } from "../../store/actions/SlideActions";
import StatisticsManagementIndex from "./StatisticsManagementIndex";
import EditAccessableDomain from "../../pages/admin/EditDomain/EditAccessableDomain";
import EditLicense from "../../pages/admin/EditLicense/EditLicense";
import { isAdmin } from "../../utils/LogicUtils";
import UploadVideoIcon from "../../common/components/images/UploadVideoIcon";
import UploadSlideIcon from "../../common/components/images/UploadSlideIcon";
import AdminUserIcon from "../../common/components/images/AdminUserIcon";
import AdminGroupIcon from "../../common/components/images/AdminGroupIcon";
import AdminChannelIcon from "../../common/components/images/AdminChannelIcon";
import AdminRecommendIcon from "../../common/components/images/AdminRecommendIcon";
import AdminProcessStatusIcon from "../../common/components/images/AdminProcessStatusIcon";
import AdminLicenseIcon from "../../common/components/images/AdminLicenseIcon";
import AdminAccessableIcon from "../../common/components/images/AdminAccessableIcon";
import AdminStatisticsIcon from "../../common/components/images/AdminStatisticsIcon";
import { DeleteMediaRecorderVideoFile } from "../../common/video/VideoActions";

interface EditAdminPageProps {
    /* モーダル表示切り替え */
    in: boolean;
    contentType: string;
    onEnter?: () => {};
    onExited?: () => {};
    // モーダル閉じる
    onClose?: () => void;
    isSaved: boolean;
    setIsSaved: (flg: boolean) => void;
    children?: React.ReactElement;
}

const theme = createTheme({
    palette: {
        primary: {
            main: "#ffffff !important",
        },
        secondary: {
            main: "#212429 !important",
        },
    },
});

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            className={styles.tabpanel}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

function a11yProps(index: any) {
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        display: "flex",
        position: "relative",
    },
    tabs: {
        width: "300px",
        height: "100vh",
        padding: "20px 20px 0 20px",
        borderRight: "none",
        display: "flex",
        backgroundColor: "#1E2329",
        fontFamily: "noto-sans-cjk-jp,sans-serif !important",
        "& .MuiTabs-indicator": {
            display: "none",
        },
    },
    tab: {
        minHeight: "auto",
        height: "50px",
        padding: "0 0 0 20px",
        margin: "5px 0",
        borderRadius: "5px",
        "& .MuiTab-wrapper": {
            display: "inline-flex",
            justifyContent: "flex-start !important",
            flexDirection: "initial !important",
            alignItems: "center !important",
            fontSize: "16px",
            "& svg": {
                marginRight: "20px",
                marginTop: "7px",
            },
        },
        "&:hover": {
            borderRadius: "5px",
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            color: "white",
        },
        "&.Mui-selected": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            color: "white",
        },
    },
}));

const EditAdminPage = React.forwardRef<HTMLDivElement, EditAdminPageProps>(function EditAdminPage(
    props,
    ref
) {
    const {
        in: open,
        contentType,
        children,
        onEnter,
        onExited,
        onClose,
        isSaved,
        setIsSaved,
        ...other
    } = props;

    const [tabMenus, setTabMenus] = useState<object>([]);
    const contentTypes = ["video", "slidestock", "management"];

    const style = useSpring({
        from: { opacity: 0 },
        to: { opacity: open ? 1 : 0 },
        onStart: () => {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: () => {
            if (!open && onExited) {
                onExited();
            }
        },
    });

    const dispatch = useDispatch();
    // tempFileデータをStoreから取得
    const { user, tempFile } = useSelector((state: AppState) => ({
        tempFile: state.slide.tempFile,
        user: state.user.user,
    }));

    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [newValue, setNewValue] = React.useState(0);
    const [openDialog, setOpenDialog] = React.useState(false);

    // ページ遷移かTempFileがあるか表示フラグ定義
    const [showDialogMsg, setShowDialogMsg] = useState(false);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        if (isSaved) {
            setValue(newValue);
        } else {
            if (tempFile.keyName !== "") {
                setShowDialogMsg(true);
            }
            setOpenDialog(true);
            setNewValue(newValue);
        }
    };

    const handleCloseDialog = () => {
        dispatch(DeleteMediaRecorderVideoFile());
        setOpenDialog(false);
        setShowDialogMsg(false);
    };

    const handleCancel = () => {
        handleCloseDialog();
        setNewValue(0);
    };

    const handleConfirm = () => {
        if (tempFile.keyName !== "") {
            // tempFileデータをクリアする
            dispatch(DeleteTempFile(tempFile.keyName));
        }
        setValue(newValue);
        setIsSaved(true);
        handleCloseDialog();
    };

    useEffect(() => {
        const tabMenusUpload = [
            {
                title: "動画アップロード",
                content: <UploadVideo setIsSaved={setIsSaved} isSaved={isSaved} />,
                icon: <UploadVideoIcon />,
            },
            {
                title: "スライドアップロード",
                content: <UploadContent setIsSaved={setIsSaved} isSaved={isSaved} />,
                icon: <UploadSlideIcon />,
            },
        ];

        const tabMenusNotAdmin = [
            {
                title: "グループ管理",
                content: <EditGroup setIsSaved={setIsSaved} isSaved={isSaved} />,
                icon: <AdminGroupIcon />,
            },
            {
                title: "進捗管理",
                content: <ConfirmProcessStatusIndex />,
                icon: <AdminProcessStatusIcon />,
            },
            {
                title: "おすすめ管理",
                content: <EditRecommend setIsSaved={setIsSaved} isSaved={isSaved} />,
                icon: <AdminRecommendIcon />,
            },
            {
                title: "チャンネル管理",
                content: <EditProgram setIsSaved={setIsSaved} isSaved={isSaved} />,
                icon: <AdminChannelIcon />,
            },
            {
                title: "統計管理",
                content: <StatisticsManagementIndex />,
                icon: <AdminStatisticsIcon />,
            },
        ];

        const tabMenusAdmin = [
            {
                title: "ユーザ管理",
                content: <EditUser setIsSaved={setIsSaved} isSaved={isSaved} />,
                icon: <AdminUserIcon />,
            },
            {
                title: "グループ管理",
                content: <EditGroup setIsSaved={setIsSaved} isSaved={isSaved} />,
                icon: <AdminGroupIcon />,
            },
            {
                title: "進捗管理",
                content: <ConfirmProcessStatusIndex />,
                icon: <AdminProcessStatusIcon />,
            },
            {
                title: "おすすめ管理",
                content: <EditRecommend setIsSaved={setIsSaved} isSaved={isSaved} />,
                icon: <AdminRecommendIcon />,
            },
            {
                title: "チャンネル管理",
                content: <EditProgram setIsSaved={setIsSaved} isSaved={isSaved} />,
                icon: <AdminChannelIcon />,
            },
            {
                title: "統計管理",
                content: <StatisticsManagementIndex />,
                icon: <AdminStatisticsIcon />,
            },
            {
                title: "アクセス管理",
                content: <EditAccessableDomain setIsSaved={setIsSaved} isSaved={isSaved} />,
                icon: <AdminAccessableIcon />,
            },
            {
                title: "ライセンス管理",
                content: <EditLicense />,
                icon: <AdminLicenseIcon />,
            },
        ];

        if (contentType === contentTypes[0] || contentType === contentTypes[1]) {
            // videoとslidestockのメニュを表示する
            setTabMenus(tabMenusUpload);
        } else {
            // 管理メニュを表示する
            const damiTabMenus = isAdmin(user?.roles) ? tabMenusAdmin : tabMenusNotAdmin;
            setTabMenus(damiTabMenus);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSaved]);

    useEffect(() => {
        // 指定したタブを表示させる
        if (contentType === contentTypes[0] || contentType === contentTypes[1]) {
            const tabIndex = contentTypes.indexOf(contentType);
            if (tabIndex !== value) setValue(tabIndex);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contentType]);

    return (
        <>
            <animated.div ref={ref} style={style} {...other}>
                <div className={classes.root}>
                    <ThemeProvider theme={theme}>
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange}
                            aria-label="Admin tabs"
                            className={classes.tabs}
                            textColor="primary"
                        >
                            {Object.values(tabMenus).map((item, index) => (
                                <Tab
                                    className={classes.tab}
                                    key={item.title}
                                    label={item.title}
                                    {...a11yProps(index)}
                                    style={{
                                        textTransform: "none",
                                        color: "var(--loading-bg)",
                                        fontFamily: "noto-sans-cjk-jp,sans-serif",
                                    }}
                                    icon={item.icon}
                                />
                            ))}
                        </Tabs>
                    </ThemeProvider>

                    {Object.values(tabMenus).map((item, index) => (
                        <TabPanel key={item.title} value={value} index={index}>
                            {/* <h1 className={styles.tabItemTitle}>{Object.keys(tabMenus)[index]}</h1> */}
                            <div className={styles.tabItem}>
                                {Object.values(tabMenus)[index].content}
                            </div>
                        </TabPanel>
                    ))}
                </div>
            </animated.div>
            <OnLeaveDialog
                openDialog={openDialog}
                dialogTitle={
                    showDialogMsg ? "コンテンツアップロード確認" : "ページを移動しますか？"
                }
                dialogContent={
                    showDialogMsg
                        ? "現在アップロードしているコンテンツファイルは失われます"
                        : "ページを移動すると、変更内容は失われます"
                }
                dialogActions={"ページ移動"}
                handleCloseDialog={handleCloseDialog}
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
            />
        </>
    );
});

export default EditAdminPage;
